const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const arabicDigits = "٠١٢٣٤٥٦٧٨٩";

export const toEnglishDigits = (value) =>
  String(value ?? "")
    .replace(/[۰-۹]/g, (digit) => String(persianDigits.indexOf(digit)))
    .replace(/[٠-٩]/g, (digit) => String(arabicDigits.indexOf(digit)));

export const sanitizeNumberInput = (
  value,
  { allowDecimal = true, allowNegative = false } = {}
) => {
  let normalized = toEnglishDigits(value)
    .replace(/[٬،,\s]/g, "")
    .replace(/٫/g, ".");

  normalized = normalized.replace(allowDecimal ? /[^0-9.-]/g : /[^0-9-]/g, "");

  if (!allowNegative) {
    normalized = normalized.replace(/-/g, "");
  } else {
    normalized = normalized.replace(/(?!^)-/g, "");
  }

  if (allowDecimal) {
    const [integerPart, ...decimalParts] = normalized.split(".");
    normalized = `${integerPart}${decimalParts.length ? `.${decimalParts.join("")}` : ""}`;
  } else {
    normalized = normalized.replace(/\./g, "");
  }

  return normalized;
};

export const formatNumberInput = (
  value,
  { allowDecimal = true, allowNegative = false } = {}
) => {
  const sanitized = sanitizeNumberInput(value, { allowDecimal, allowNegative });

  if (!sanitized || sanitized === "-") return sanitized;

  const isNegative = sanitized.startsWith("-");
  const unsigned = isNegative ? sanitized.slice(1) : sanitized;
  const hasTrailingDecimal = unsigned.endsWith(".");
  const [integerRaw, decimalRaw] = unsigned.split(".");
  const integerPart = integerRaw
    ? Number(integerRaw).toLocaleString("fa-IR")
    : "۰";
  const decimalPart = decimalRaw !== undefined ? toEnglishDigits(decimalRaw) : undefined;

  return `${isNegative ? "-" : ""}${integerPart}${
    hasTrailingDecimal ? "." : decimalPart !== undefined ? `.${decimalPart}` : ""
  }`;
};

export const parseFormattedNumber = (
  value,
  options = {}
) => sanitizeNumberInput(value, options);

export const formatDisplayNumber = (value, maximumFractionDigits = 2) =>
  Number(value || 0).toLocaleString("fa-IR", {
    maximumFractionDigits,
  });
